<template>
	
</template>

<script>
	import Vue from 'vue';

	export default Vue.extend({
		name: "BasePage",
		methods: {
			extractErrorMessage(originalError){
				let errorStart = originalError.indexOf('Nested error is');
				if(errorStart == -1){
					return originalError;
				}
				let woutNestedError = originalError.slice(errorStart + 'Nested error is'.length + 1);
				let exceptionStart = woutNestedError.indexOf("Exception:");
				if(exceptionStart == - 1){
					return woutNestedError
				}
				return woutNestedError.slice(exceptionStart + 'Exception:'.length + 1);
			}
		}
	});
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/app/BasePage.vue